export const B2C_ACCOUNT_PATH = '/customer/account/v1'; // TODO: Get b2c orders path
export const B2B_ACCOUNT_PATH = '/b2b/user/account';
export const B2B_ACCOUNT_ORDERS_PATH = '/b2b/customer/order/v1';
export const OMS_ORDERS_PATH = '/oms/customer/order/v1';
export const CMS_ORDERS_PATH = '/cms/customer/order/v1';
export const OMM_ORDERS_PATH = '/omm/customer/order/v1';
export const RETURN_PATH = `/customer/returns/v1`;
export const RESCHEDULE_PATH = '/rms/customer/order/v1';

/**
 * B2C API paths:
 */
export const B2C_ACCOUNT_PROFILE_PATH = (memberId: string) =>
  `${B2C_ACCOUNT_PATH}/${memberId}/profile?checkPhoneEligibility=true`;
export const B2C_UPDATE_PROFILE_DATA_PATH = (memberId: string) =>
  `${B2C_ACCOUNT_PATH}/${memberId}/profile`;

/**
 * B2B API Paths:
 */

// Common
export const B2B_ACCOUNT_PATH_WITH_USER_ID = (userId: string) =>
  `${B2B_ACCOUNT_PATH}/${userId}`;
export const B2B_ACCOUNT_PROFILE_PATH = (userId: string, svocId: string) =>
  `${B2B_ACCOUNT_PATH_WITH_USER_ID(userId)}/customer/${svocId}/profile`;

// Buildertrend
export const B2B_BUILDERTREND_LINK_PATH = (userId: string, svocId: string) =>
  `${B2B_ACCOUNT_PATH}/${userId}/customer/${svocId}/integration/bt/link`;
export const B2B_BUILDERTREND_UNLINK_PATH = (userId: string, svocId: string) =>
  `${B2B_ACCOUNT_PATH}/${userId}/customer/${svocId}/integration/bt/delete`;

// Linked Accounts
export const B2B_LOGIN_BUSINESS_ACCOUNT_START_PATH = `${B2B_ACCOUNT_PATH_WITH_USER_ID}/customer`;

/**
 * OMS API Paths:
 * Area for new oms service to combinded b2b and b2c calls
 */

// Order Subscriptoins
export const OMS_ORDER_SUBSCRIPTIONS_HMAC_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/auth/gethmactoken`;

// Order History
export const OMS_ORDER_HISTORY_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/orderhistory`;

// Buy It Again
export const OMS_BUY_IT_AGAIN_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/buyitagain`;

// Quickbooks
export const OMS_EXPORT_HISTORY_TO_QUICKBOOKS_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/qb/desktop/sync`;
export const OMS_QUICKBOOKS_LOGIN_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/qb/login`;
export const OMS_QUICKBOOKS_OAUTH_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/qb/Oauth`;
export const OMS_QUICKBOOKS_ORDERS_COUNT_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/qb/count`;
export const OMS_QUICKBOOKS_SYNC_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/qb/sync`;

// Order Details B2B & B2C Auth
export const OMS_ORDER_DETAILS_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/orderdetails`;

// Order Details B2C Guest
export const OMS_ORDER_DETAILS_PATH_GUEST = `${OMS_ORDERS_PATH}/user/guest/orderdetails`;

// PTC Documents
export const OMS_PTC_DOCUMENTS_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/invoices`;

// Xref Search
export const OMS_XREF_SEARCH_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/xref/search`;

/**
 * View Big Receipt to stay in legacy until backend gives the ok to move to oms endpoint.
 * Get big receipt from document manager
 */

export const OMS_VIEW_BIG_RECEIPT_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/receipt/view/bigReceipt`;

// this path has not been confirmed yet. Ashok is doing a Spike Story for this, and one of the API might be redundant based on the decision made by Ashok.
export const VIEW_B2B_INSTORE_RECEIPT_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/receipts/store/view`;
export const VIEW_B2C_INSTORE_RECEIPT_PATH = `/customer/order/v1/ecereipt/detail`;

export const OMS_ORDER_TRACKING_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/trackingdetails`;
// export const OMS_ORDER_TRACKING_GUEST_PATH = `${OMS_ORDERS_PATH}/guest/trackingdetails`;

// Retrieves truck information for BODFS deliveries through DMS
export const OMS_TRACK_YOUR_TRUCK_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/trackyourtruck`;
// export const B2C_ORDER_TRACK_YOUR_TRUCK_GUEST_PATH = `${B2C_ACCOUNT_PATH}/guest/trackyourtruck`;

// Business Tools

export const OMS_BUSINESS_TOOLS_SPEND_BY_DEPARTMENT_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/businesstools/topspendbydepartment`;
export const OMS_BUSINESS_TOOLS_SPEND_BY_STORE_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/businesstools/topspendbystore`;
export const OMS_BUSINESS_TOOLS_SPEND_BY_ITEMS_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/businesstools/topspendbyitemspend`;
export const OMS_BUSINESS_TOOLS_SPEND_BY_QUANTITY_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/businesstools/topspendbyitemquantity`;
export const OMS_BUSINESS_TOOLS_SPEND_BY_JOB_NAME_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/businesstools/topspendbyjobname`;

// Linked Accounts

export const OMS_SPEND_ACROSS_ACCOUNTS_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/family/totalspend`;
export const OMS_INDIVIDUAL_SPEND_ACCOUNTS_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/family/members`;
export const OMS_EXPORT_LINKED_ACCOUNT_HISTORY_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/offline/processing`;

// Downloads

export const OMS_OFFLINE_DOWNLOADS_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/offline/csvfilelist`;
export const OMS_GET_OFFLINE_DOWNLOAD_FILE_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/offline/csvfilecontent`;
export const OMS_PH_OFFLINE_DOWNLOAD_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/offline/processing`;

// Add Receipt
export const OMS_ADD_RECEIPT_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/receipts`;

// Delivery Tracker
export const OMS_DELIVERY_TRACKER_PATH = (userId?: string) =>
  `${OMS_ORDERS_PATH}/user/${userId || 'guest'}/deliveryTracker`;

// Local/Open delivery order history path
export const OMS_ORDER_HISTORY_LOCAL_DELIVERY = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/orderhistory/localdelivery`;

// Local/Open delivery order details path
export const OMS_ORDER_DETAILS_LOCAL_DELIVERY_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/orderdetails/localdelivery`;

/**
 * -----------------------------------
 */

export const OMS_VIEW_RECEIPT_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/receipt/view`;

// Total Spend
export const OMS_TOTAL_SPEND_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/spend`;

// Locker Code
export const OMS_LOCKER_CODE_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/locker/code`;

// CPS Item Level Search
export const CPS_ITEM_LEVEL_SEARCH_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/search/item`;

// CPS Search Filters
export const CPS_FILTERS_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/filters`;

// Guest Order Tracking APIs
export const OMS_GUEST_ORDER_TRACKING_PATH = `${OMS_ORDERS_PATH}/user/guest/orderdetails`;

// OMS Edit PO/Job name
export const OMS_EDIT_JOB_NAME_PATH = (userId: string) =>
  `${OMS_ORDERS_PATH}/user/${userId}/editPOJobName`;

/**
 * CMS Cancel APIs
 */
// Auth APIs
export const CMS_CREATE_PATH = (userId: string) =>
  `${CMS_ORDERS_PATH}/user/${userId}/create`;
export const CMS_ELIGIBILITY_PATH = (userId: string) =>
  `${CMS_ORDERS_PATH}/user/${userId}/eligibility`;
export const CMS_REASON_CODES_PATH = (userId: string) =>
  `${CMS_ORDERS_PATH}/user/${userId}/cancellation-reason-codes`;

// UnAuth/Guest APIs
export const CMS_GUEST_CREATE_PATH = `${CMS_ORDERS_PATH}/user/guest/create`;
export const CMS_GUEST_ELIGIBILITY_PATH = `${CMS_ORDERS_PATH}/user/guest/eligibility`;
export const CMS_GUEST_REASON_CODES_PATH = `${CMS_ORDERS_PATH}/user/guest/cancellation-reason-codes`;

/**
 * RMS Reschedule APIs
 */
// Auth APIs
export const RMS_AVAILABLE_DELIVER_SLOTS_PATH = (userId: string) =>
  `${RESCHEDULE_PATH}/user/${userId}/available-delivery-slots`;
export const RMS_RESCHEDULES_PATH = (userId: string) =>
  `${RESCHEDULE_PATH}/user/${userId}/reschedule-delivery`;

// UnAuth/Guest APIs
export const RMS_AVAILABLE_DELIVER_SLOTS_GUEST_PATH = `${RESCHEDULE_PATH}/user/guest/available-delivery-slots`;
export const RMS_RESCHEDULES_GUEST_PATH = `${RESCHEDULE_PATH}/user/guest/reschedule-delivery`;

/**
 * OMM Order Management APIs
 * Holds paths for OMM service for auth and unauth paths
 */
// Auth APIs
export const OMM_EDIT_PICKUP_PERSON_PATH = (userId: string) =>
  `${OMM_ORDERS_PATH}/user/${userId}/edit-pickup-person`;
export const OMM_EDIT_DELIVERY_INSTRUCTIONS_PATH = (userId: string) =>
  `${OMM_ORDERS_PATH}/user/${userId}/edit-delivery-instructions`;
export const OMM_SELECT_NEW_PICKUP_LOCATION_PATH = (userId: string) =>
  `${OMM_ORDERS_PATH}/user/${userId}/store-pickup/select-new-location`;
export const OMM_GET_LOCATIONS_PATH = (userId: string) =>
  `${OMM_ORDERS_PATH}/user/${userId}/store-pickup/get-locations`;
export const OMM_UPDATE_PICKUP_LOCATION_PATH = (userId: string) =>
  `${OMM_ORDERS_PATH}/user/${userId}/store-pickup/update-pickup-location`;
export const OMM_SUSPEND_CART_PATH = (userId: string) =>
  `${OMM_ORDERS_PATH}/user/${userId}/store-pickup/suspend-cart`;
export const OMM_EDIT_DELIVERY_ADDRESS_VALIDATE_ADDRESS = (userId: string) =>
  `${OMM_ORDERS_PATH}/user/${userId}/validate-address`;
export const OMM_EDIT_DELIVERY_ADDRESS_UPDATE_ADDRESS = (userId: string) =>
  `${OMM_ORDERS_PATH}/user/${userId}/edit-delivery-address/update-address`;
export const OMM_EDIT_DELIVERY_ADDRESS_CREATE_CART = (userId: string) =>
  `${OMM_ORDERS_PATH}/user/${userId}/edit-delivery-address/create-cart`;
export const OMM_EDIT_DELIVERY_ADDRESS_SUSPEND_CART = (userId: string) =>
  `${OMM_ORDERS_PATH}/user/${userId}/edit-delivery-address/suspend-cart`;
export const OMM_EDIT_DELIVERY_ADDRESS_GET_CITIES_BY_ZIPCODE = (
  userId: string,
) => `${OMM_ORDERS_PATH}/user/${userId}/get-cities-by-zipcode`;
export const OMM_EDIT_DELIVERY_ADDRESS_ADD_ADDRESS = (userId: string) =>
  `${OMM_ORDERS_PATH}/user/${userId}/add-address`;
export const OMM_EDIT_DELIVERY_ADDRESS_APPIFY_PATH = (userId: string) =>
  `${OMM_ORDERS_PATH}/user/${userId}/get-addresses`;
export const OMM_AVAILABLE_DELIVERY_SLOTS_PATH = (userId: string) =>
  `${OMM_ORDERS_PATH}/user/${userId}/available-delivery-slots`;
export const OMM_AVAILABLE_FULFILLMENT_OPTIONS_PATH = (userId: string) =>
  `${OMM_ORDERS_PATH}/user/${userId}/available-fulfillment-options`;

// UnAuth/Guest APIs
export const OMM_GUEST_EDIT_DELIVERY_INSTRUCTIONS_PATH = `${OMM_ORDERS_PATH}/user/guest/edit-delivery-instructions`;
export const OMM_GUEST_DELIVERY_ADDRESS_APPIFY_PATH = `${OMM_ORDERS_PATH}/user/guest/get-addresses`;
export const OMM_AVAILABLE_DELIVERY_SLOTS_GUEST_PATH = `${OMM_ORDERS_PATH}/user/guest/available-delivery-slots`;
export const OMM_AVAILABLE_FULFILLMENT_OPTIONS_GUEST_PATH = `${OMM_ORDERS_PATH}/user/guest/available-fulfillment-options`;

/**
 * RTMS Return APIs
 */
// Auth APIs
export const PRINT_RETURN_SHIPPING_LABEL_PATH = (userId: string) =>
  `${RETURN_PATH}/user/${userId}/print/returnshippinglabel`;

// UnAuth/Guest APIs
export const RETURN_SORIS_CANCEL_PATH = `${RETURN_PATH}/cancelsoris`;

// ----- END OF RETURN SERVICE URL
